import { PropertyValue } from '../domains/results';
import moment from 'moment';

export interface ISeries {
  name: string;
  shortName: string;
  type: 'scatter' | 'line' | 'column';
  color?: string;
  axisName: string | 'untitled';
  data: {
    x: number | Date;
    y: number | null;
  }[];
}

export interface ValueAxis {
  name: string;
  min: number;
  max: number;
  title: string;
}

export const generateValueAxis = (
  valuesAxisArray: ValueAxis[],
  prop: PropertyValue,
  data: ISeries['data'],
): ValueAxis[] => {
  const valAxis: ValueAxis | undefined = valuesAxisArray.find(
    (a) => a.name === (prop.unit || prop.name),
  );
  const numberArray: number[] = data
    .map((d) => d.y)
    .filter((d) => +(d || 0) === d) as number[];
  const minValue = Math.min(...numberArray);
  const maxValue = Math.max(...numberArray) || 1;
  if (valAxis) {
    valAxis.min = Math.min(valAxis.min, minValue);
    valAxis.max = Math.max(valAxis.max, maxValue);
  } else {
    valuesAxisArray.push({
      name: prop.unit || prop.name,
      title: prop.unit || prop.name,
      max: maxValue,
      min: minValue,
    });
  }

  return valuesAxisArray;
};

export const getRandomColor = (i: number) => {
  const definedColors = [
    '#3366cc',
    '#dc3912',
    '#ff9900',
    '#109618',
    '#990099',
    '#0099c6',
    '#dd4477',
    '#66aa00',
    '#b82e2e',
    '#316395',
    '#994499',
    '#22aa99',
    '#aaaa11',
    '#6633cc',
  ];
  if (definedColors[i]) {
    return definedColors[i];
  }
  const letters = '0123456789ABCDEF';
  let color = '#';
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};

export const seriesName = (
  countDataset: number,
  date: string,
  name: string,
): string => {
  return countDataset > 1
    ? name + ' ' + moment(date).format('DD MMM YYYY HH:mm:ss')
    : name;
};
